import React from "react";
import "./Pagination.css";

export default function Pagination({
  total = 0,
  current = 1,
  perPage = 12,
  onPageChange,
}) {
  const totalPages = Math.ceil(total / perPage) || 1;
  const pages = [];
  const start = Math.max(1, current - 2);
  const end = Math.min(totalPages, current + 2);

  for (let i = start; i <= end; i++) pages.push(i);

  return (
    <div className="pl-pagination">
      <button
        disabled={current === 1}
        onClick={() => onPageChange(current - 1)}
      >
        &lt; Prev
      </button>
      {start > 1 && <button onClick={() => onPageChange(1)}>1</button>}
      {start > 2 && <span className="dots">...</span>}
      {pages.map((p) => (
        <button
          key={p}
          className={p === current ? "active" : ""}
          onClick={() => onPageChange(p)}
        >
          {p}
        </button>
      ))}
      {end < totalPages - 1 && <span className="dots">...</span>}
      {end < totalPages && (
        <button onClick={() => onPageChange(totalPages)}>{totalPages}</button>
      )}
      <button
        disabled={current === totalPages}
        onClick={() => onPageChange(current + 1)}
      >
        Next &gt;
      </button>
    </div>
  );
}
